import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { fromEvent, Observable, Subscription } from 'rxjs';
import * as loginSelectors from '../../../../../root-store/login-store/login.selector';
import { select, Store } from '@ngrx/store';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { ToastrService } from 'ngx-toastr';
import * as selectorsRelationship from '../../../../../root-store/relationship-store/relationship.selector';
import { FormControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UserInviteComponent } from '@app/shared/component/user-invite/user-invite.component';
import { UserInviteSuccessScreenComponent } from '@app/modules/relationship/components/dialogs/user-invite-success-screen/user-invite-success-screen.component';
import * as selectors from '../../../../../root-store/vault-store/vault.selector';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { SelectedVaultInfo, VaultSelectionBroadcastService } from '@app/shared/services/vault/vault-selection-broadcast.service';
import { DocumentService } from '@app/shared/services';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { EditTemplateBasicFormComponent } from '@app/shared/component/discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/create-associated-form/edit-template-basic-form/edit-template-basic-form.component';
import { Router } from '@angular/router';
import { getWorkspaceItem } from '@app/root-store/workspaces-store/selector';
import { MatSelectChange } from '@angular/material/select';
import { getAllProfessionalRelationShipSortSelector } from '../../../../../root-store/relationship-store/relationship.selector';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { sanitizePlainTextStrict, stripHtmlTags } from '@app/shared/utils';

@AutoUnsubscribe()
@Component({
  selector: 'add-entity-dilaog',
  templateUrl: './add-entity-dilaog.component.html',
  styleUrls: ['./add-entity-dilaog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddEntityDilaogComponent implements OnInit, OnDestroy {
  @ViewChild(EditTemplateBasicFormComponent) editTemplateBasicForm!: EditTemplateBasicFormComponent;

  stateObject;
  currentUser;
  forms: any;
  documentForm;
  formData = [];
  vault_id: any;
  vaults: any[][];
  current_template;
  workspaceId = null;
  securityStateObject;
  screenWidth: number;
  membersSection = false;
  vaultStateObject$: any;
  selectedMembers = [];
  allWorkspaceMembers = [];
  allEntityTemplates = [];
  placeholderVaultOptions = [];
  title = 'Manage Members';
  headerText = 'Add Entity';
  entityNameSection = true;
  entityForm: UntypedFormGroup;
  searchStringState: FormControl;
  subscription = new Subscription();
  allNonProfessionalExistingUsers = [];
  resizeObservable$: Observable<Event>;
  searchTextPlaceHolder = 'Search Connections';
  connectionUserFormControl = new UntypedFormControl();
  defaultVaultIdFromUrl: string | null = null;
  selectedVaultFromBroadcast: SelectedVaultInfo | null = null;
  readonly placeholderEntityId = 2197;
  readonly placeholderTooltip =
    "Use this placeholder entity if you don't own the entity. This will not create an entity template or an entity vault.";
  hidePlaceholderEntity = false;

  constructor(
    public dialogRef: MatDialogRef<AddEntityDilaogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store,
    private _router: Router,
    private dialog: MatDialog,
    private _fb: UntypedFormBuilder,
    private vaultService$: VaultStoreEffects,
    private vaultService: SharedVaultService,
    private documentService: DocumentService,
    private toastr: ToastrService,
    private _cd: ChangeDetectorRef,
    private vaultSelectionBroadcastService: VaultSelectionBroadcastService
  ) {
    this.hidePlaceholderEntity = !!this.data?.hidePlaceholderEntity;
    this.vaultStateObject$ = this.vaultService$.vaultObject;
    this.defaultVaultIdFromUrl = this.extractVaultIdFromUrl();
    this.selectedVaultFromBroadcast = this.vaultSelectionBroadcastService.getSelectedVaultSnapshot();
    this.subscription.add(
      this.vaultSelectionBroadcastService.getSelectedVault().subscribe((selection) => {
        this.selectedVaultFromBroadcast = selection;
        const placeholderControl = this.entityForm?.get('placeholderVault');
        const preferredVaultId = this.getPreferredPlaceholderVaultId();
        if (this.isPlaceholderSelected && placeholderControl && preferredVaultId && String(placeholderControl.value) !== String(preferredVaultId)) {
          placeholderControl.setValue(preferredVaultId);
        }
        this._cd.markForCheck();
      })
    );
    this.subscription.add(
      this.vaultStateObject$.subscribe((item) => {
        this.stateObject = item;
        this.forms = item.forms;
        this.vaults = item.vaults;
        this.placeholderVaultOptions = this.flattenVaultList(item?.vaults);
        const placeholderControl = this.entityForm?.get('placeholderVault');
        const preferredVaultId = this.getPreferredPlaceholderVaultId();
        if (this.isPlaceholderSelected && placeholderControl && preferredVaultId && String(placeholderControl.value) !== String(preferredVaultId)) {
          placeholderControl.setValue(preferredVaultId);
        }
        this._cd.markForCheck();
      })
    );
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.searchStringState = new FormControl();
    this.entityForm = this._fb.group({
      entityName: ['', Validators.required],
      entityType: ['', Validators.required],
      vaultOwner: [''],
      placeholderVault: [''],
    });

    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserFullDetails).subscribe((res) => {
        this.currentUser = res;
        const creator = {
          id: this.currentUser?.id,
          user_id: this.currentUser?.id,
          memberUser: {
            id: this.currentUser?.id,
            name: this.currentUser?.name,
            user_profile_image_url: this.currentUser?.profile_image_url,
            hasGuardianPermissions: false,
          },
          type: 'owner',
          is_creator: true,
        };
        this.selectedMembers.unshift(creator);
      })
    );

    this.subscription.add(
      this.entityForm.get('entityType').valueChanges.subscribe((entityType) => {
        const isPlaceholder = entityType === this.placeholderEntityId;
        const placeholderControl = this.entityForm.get('placeholderVault');
        if (isPlaceholder) {
          placeholderControl.setValidators([Validators.required]);
          if (!placeholderControl.value && this.placeholderVaultOptions.length) {
            const preferredVaultId = this.getPreferredPlaceholderVaultId();
            if (preferredVaultId) {
              placeholderControl.setValue(preferredVaultId);
            }
          }
        } else {
          placeholderControl.clearValidators();
          placeholderControl.setValue('');
        }
        placeholderControl.updateValueAndValidity({ emitEvent: false });
        this._cd.markForCheck();
      })
    );

    if (this.currentUser.user_type === 'Professional' && this._router.url.includes('/workspace/')) {
      this.entityForm.get('vaultOwner').setValidators([Validators.required]);
      this.entityForm.get('vaultOwner').updateValueAndValidity();
      const split_url = this._router.url.split('/');
      this.workspaceId = split_url[2];
      this.subscription.add(
        this.store.select(getWorkspaceItem(this.workspaceId)).subscribe((data) => {
          this.allWorkspaceMembers = data.members
            .filter((x) => x.status === 'accept' && x.type === 'family')
            .map((x) => ({ ...x, ...x.userDetails }));
        })
      );
    } else if (this.currentUser.user_type === 'Professional') {
      this.entityForm.get('vaultOwner').clearValidators();
      this.entityForm.get('vaultOwner').updateValueAndValidity();
      this.subscription.add(
        this.store.select(getAllProfessionalRelationShipSortSelector()).subscribe((data) => {
          this.allWorkspaceMembers = [
            {
              ...this.currentUser,
              user_first_name: this.currentUser.first_name,
              user_last_name: this.currentUser.first_middle_name,
              user_id: this.currentUser.id,
              name: this.currentUser?.name,
            },
            ...data.filter((x) => x.connection_status == 'approved').map((x) => ({ ...x, name: x?.user_first_name + ' ' + x?.user_last_name })),
          ];
        })
      );
    }

    this.getAllEntityTemplates();
    this.getAllNonProfessionalExistiongUsers();
    if (this.data?.entityType) {
      this.entityForm.get('entityType').setValue(this.data.entityType);
    }
    if (this.data?.entityName) {
      this.entityForm.get('entityName').setValue(this.data.entityName);
    }
    this._cd.markForCheck();
  }

  getAllEntityTemplates() {
    this.subscription.add(
      this.store.pipe(select(selectors.getTemplateByCategory('Entities', true))).subscribe((response) => {
        const placeholderTemplate = response?.find(
          (item) => item?.id === this.placeholderEntityId || item?.type?.toLowerCase() === 'placeholder entity'
        );
        const otherTemplates = response?.filter((item) => item?.id !== placeholderTemplate?.id) ?? [];
        let templates = placeholderTemplate ? [...otherTemplates, placeholderTemplate] : otherTemplates;
        if (this.hidePlaceholderEntity) {
          templates = templates.filter((item) => item?.id !== this.placeholderEntityId && item?.type?.toLowerCase() !== 'placeholder entity');
        }
        this.allEntityTemplates = templates;
        this._cd.detectChanges();
      })
    );
  }

  getAllNonProfessionalExistiongUsers() {
    this.subscription.add(
      this.store.select(selectorsRelationship.getAndFilterNonProfessionalExcludeExistingUser('', [])).subscribe((data) => {
        const updatedObject = [];
        data.forEach((element) => {
          const tempEllemt = {
            ...element,
            id: element?.user_id,
            name: element?.user_first_name + ' ' + element?.user_last_name,
            type: 'member',
          };
          updatedObject.push(tempEllemt);
        });
        this.allNonProfessionalExistingUsers = updatedObject.map(({ id, user_id, name, relationship_name, user_profile_image_url }) => ({
          id,
          user_id,
          name,
          relationship_name,
          user_profile_image_url,
        }));
        this._cd.detectChanges();
      })
    );
  }

  deleteMember(user) {
    this.selectedMembers = this.selectedMembers.filter((item) => item.id !== user.id);
    this.handleFamilyusersSelection(this.selectedMembers);
  }

  private getSanitizedEntityName(entityName): string {
    const validation = sanitizePlainTextStrict(entityName);
    if (!validation.isValid) {
      return '';
    }
    return validation.sanitized;
  }

  createStandaloneVaultForEntity() {
    if (this.isPlaceholderSelected) {
      const selectedVaultId = this.entityForm.get('placeholderVault')?.value;
      if (!selectedVaultId) {
        this.toastr.error('Please select a vault for the placeholder entity.');
        return;
      }
      this.createEntityTemplate({ id: selectedVaultId, isPlaceholder: true });
      return;
    }
    const currentUserId = this.stateObject.userId ? this.stateObject.userId : this.currentUser?.id;
    // Strip HTML tags from entity name to prevent HTML injection
    const entityNameRaw = this.entityForm.get('entityName').value || '';
    const entityNameSanitized = this.getSanitizedEntityName(entityNameRaw);
    if (!entityNameSanitized) {
      this.toastr.error('Entity name cannot be empty.');
      return;
    }
    const payload = {
      name: entityNameSanitized,
      type: 'entity',
      user_id: currentUserId,
      member: this.selectedMembers.map(({ user_id, type }) => ({ user_id, type })),
      ...(this.workspaceId && { workspace_id: this.workspaceId }),
    };
    this.subscription.add(
      this.vaultService.createVault(payload).subscribe(
        async (data) => {
          if (data) {
            await this.createEntityTemplate(data);
          }
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  async createEntityTemplate(data) {
    const formData: any = await this.createformIdForFirstUploadDocument({
      currentUserId: this.stateObject?.userId ?? this.currentUser?.id,
      vaultFormId: this.entityForm.get('entityType').value,
      vaultId: data.id,
    });
    this.formData = [];
    this._cd.detectChanges();
    this.initFormData(formData.vault_form_id);
    const updatedTemplateData = await this.updateFormTemplateData(formData.hub_vault_user_form_id);
    await this.updateUserFormsFormName(formData.hub_vault_user_form_id);
    updatedTemplateData['hub_vault_user_form_id'] = formData.hub_vault_user_form_id;
    updatedTemplateData['vault_id'] = this.vault_id;
    try {
      const vaultsObservable = this.vaultService.getVaults(this.currentUser.id);
      this.subscription.add(
        vaultsObservable.subscribe(
          (response) => {},
          (error) => {}
        )
      );
    } catch (error) {}

    this.dialogRef.close({ status: 'success', data: updatedTemplateData });
  }

  createformIdForFirstUploadDocument(argument) {
    return new Promise((resolve, reject) => {
      const data = {
        user_id: argument.currentUserId,
        vault_form_id: argument.vaultFormId,
        vaultId: argument.vaultId,
        url: this.workspaceId ? `/workspace/${this.workspaceId}/vault` : this._router.url,
      };
      this.subscription.add(
        this.documentService.getforIdForFirstUploadDocument(data, loaderTypes.mainAnimation).subscribe(
          (res) => {
            try {
              this.vault_id = res['vault_user_form_id'].vault_id;
              this.securityStateObject = res['vault_user_form_id'].public_key;
            } catch (error) {
              this.toastr.error(error.error.message);
            }
            if (res.vault_user_form_id.vault_user_form_id) {
              resolve({ vault_form_id: argument.vaultFormId, hub_vault_user_form_id: res.vault_user_form_id.vault_user_form_id, argument });
            }
          },
          (error) => {
            this.toastr.error(error.error.message);
            reject(error);
          }
        )
      );
    });
  }

  initFormData(vaultFormId) {
    this.current_template = this.forms.find((x) => x.id === vaultFormId);
    this.documentForm = this._fb.group({
      documentType: ['', Validators.required],
      documentName: [stripHtmlTags(this.entityForm.get('entityName')?.value || ''), Validators.required],
      status_progress: ['need to add', Validators.required],
      formSelection: ['', Validators.required],
      selectSaveFolder: ['', Validators.required],
      selectOfficeSaveFolder: ['', Validators.required],
      dynamicFieldsForm: new UntypedFormArray([]),
      beneFicaryForm: new UntypedFormArray([]),
      attributeFormsList: new UntypedFormArray([]),
      showNotes: [''],
      physicalLocation: [''],
      notes: [''],
      expiration_date: [''],
      expiration_notification: [''],
      review_date: [''],
      review_notification: [''],
      renewal_notification: [''],
      renewal_date: [''],
      recurring_expiration: [''],
      value_currency: ['USD'],
      value_current_currency: [''],
      value_is_appraisal: [''],
      value_appraisal_date: [''],
    });
    this.formData = this.current_template.template;
    this._cd.detectChanges();
  }

  updateFormTemplateData(vault_user_form_id, isShowLoader = true) {
    return new Promise(async (resolve, reject) => {
      const dynamicFieldsValue = this.documentForm?.controls?.dynamicFieldsForm?.value?.[0] ?? {
        foreignDisregardedEntityFullLegalNameofEntity: stripHtmlTags(this.entityForm.get('entityName')?.value || ''),
      };
      const payload = {
        id: vault_user_form_id,
        status_progress: 'need to add',
        user_id: this.stateObject?.userId ?? this.currentUser?.id,
        form_data: {
          beneFicaryForm: [],
          dynamicFieldsForm: dynamicFieldsValue,
          showNotes: undefined,
        },
        user_pk: this.securityStateObject?.public_key,
      };
      this.subscription.add(
        this.documentService.updateFormTampletData(payload, null, undefined, undefined, false, undefined, isShowLoader).subscribe(
          (res) => {
            resolve(res);
          },
          (error) => {
            this.toastr.error(error.error.message);
            reject(error);
          }
        )
      );
    });
  }

  updateUserFormsFormName(hub_vault_user_form_id) {
    // Strip HTML tags from entity name to prevent HTML injection
    const entityNameRaw = this.entityForm.get('entityName').value || '';
    const entityName = stripHtmlTags(entityNameRaw);
    
    return new Promise((resolve) => {
      let dynamicFieldsArray = this.documentForm?.get('dynamicFieldsForm') as UntypedFormArray;
      if (!dynamicFieldsArray) {
        dynamicFieldsArray = new UntypedFormArray([
          this._fb.group({
            foreignDisregardedEntityFullLegalNameofEntity: entityName,
          }),
        ]);
        this.documentForm = this._fb.group({
          dynamicFieldsForm: dynamicFieldsArray,
          beneFicaryForm: new UntypedFormArray([]),
          attributeFormsList: new UntypedFormArray([]),
        });
      } else if (!dynamicFieldsArray.length) {
        dynamicFieldsArray.push(
          this._fb.group({
            foreignDisregardedEntityFullLegalNameofEntity: entityName,
          })
        );
      } else {
        dynamicFieldsArray.at(0).patchValue({ foreignDisregardedEntityFullLegalNameofEntity: entityName }, { emitEvent: false });
      }
      this.subscription.add(
        this.documentService
          .saveNameWithAction(
            {
              form_name: entityName,
              id: hub_vault_user_form_id,
              naming_convention: this.current_template?.naming_convention,
              dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
              user_id: this.stateObject?.userId ?? this.currentUser?.id,
              current_template: this.current_template,
              filterArrayItems: this.editTemplateBasicForm?.filterArrayItems ?? [],
              vault_id: this.vault_id,
              vault_list: this.vaults,
            },
            true
          )
          .subscribe(
            (res) => {
              resolve(res);
            },
            (error) => {
              this.toastr.error(error.error.message);
            }
          )
      );
    });
  }

  openInviteDialog() {
    const data = {
      disableSelectionOption: true,
      custom_user_type: 'normal',
      isSharedVault: true,
    };
    const modalRef = this.dialog.open(UserInviteComponent, {
      data: data,
      autoFocus: false,
      panelClass: 'full-window-dialog-2-mobile-responsive',
    });
    this.subscription.add(
      modalRef.afterClosed().subscribe(
        (res) => {
          res['user'].user_id = res.user.to_user_id ? res.user.to_user_id : res.user.id;
          this.selectConnectedUser(res.user);
          if (res && res['success'] == true) {
            if (res['isexistingUser']) {
              this.toastr.success(`Connection request has been sent to ${res.FullName}`);
            } else {
              this.dialog.open(UserInviteSuccessScreenComponent, {
                autoFocus: false,
                panelClass: 'full-window-dialog-2',
                data: res,
              });
            }
          }
        },
        (error) => {
          this.toastr.error('Error in inviting user', error.error.message);
        }
      )
    );
  }

  selectConnectedUser(user) {
    this.connectionUserFormControl.disable();
    const memberUser = {
      id: user.id ? user.id : user.user_id,
      user_id: user.id ? user.id : user.user_id,
      from_user_id: user.from_user_id,
      connection_status: user.connection_status,
      relationship_name: user.relationship_name,
      memberUser: user,
      type: 'member',
    };
    setTimeout(() => {
      this.connectionUserFormControl.enable();
    }, 500);
    this.selectedMembers = [...this.selectedMembers, memberUser];
    this.handleFamilyusersSelection(this.selectedMembers);
  }

  nextItem(finish: boolean) {
    if (!finish && this.entityNameSection) {
      this.entityNameSection = false;
      this.membersSection = true;
      if (this.currentUser.user_type === 'Professional') {
        if (this.selectedMembers.findIndex((x) => x.id === this.currentUser.id) === -1) {
          const memberUser = {
            id: this.currentUser.id ? this.currentUser.id : this.currentUser.user_id,
            user_id: this.currentUser.id ? this.currentUser.id : this.currentUser.user_id,
            from_user_id: this.currentUser.from_user_id,
            connection_status: this.currentUser.connection_status,
            relationship_name: this.currentUser.relationship_name,
            memberUser: this.currentUser,
            type: 'member',
          };
          this.selectedMembers = [...this.selectedMembers, memberUser];
        }
      }
      this._cd.detectChanges();
    }
    if (finish) {
      this.createStandaloneVaultForEntity();
    }
  }

  backItem() {
    if (this.membersSection) {
      this.membersSection = false;
      this.entityNameSection = true;
    }
    this._cd.detectChanges();
  }

  isUserDisabledToSkip() {
    if (this.entityNameSection) {
      const isPlaceholder = this.isPlaceholderSelected;
      const isProfessional = this.currentUser?.user_type === 'Professional';
      if (
        this.entityForm.get('entityName')?.value === '' ||
        this.entityForm.get('entityType')?.value === '' ||
        (isPlaceholder ? this.entityForm.get('placeholderVault')?.value === '' : false) ||
        (isProfessional && !isPlaceholder ? this.entityForm.get('vaultOwner')?.value === '' : false)
      ) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  onSelectChange(event: MatSelectChange) {
    const selectedUserDetails = this.allWorkspaceMembers.filter((user) => user.user_id === this.entityForm.controls['vaultOwner'].value)[0];
    this.selectedMembers = this.selectedMembers.filter((member) => !member.is_creator);
    const creator = {
      id: selectedUserDetails?.user_id,
      user_id: selectedUserDetails?.user_id,
      memberUser: {
        id: selectedUserDetails?.user_id,
        name: selectedUserDetails?.name,
        user_profile_image_url: selectedUserDetails.userDetails?.profile_image_url,
        hasGuardianPermissions: false,
      },
      type: 'owner',
      is_creator: true,
    };
    this.selectedMembers.unshift(creator);
  }

  disableWhiteSpaceOnFirstCharacter(event) {
    if (event.target.selectionStart === 0 && (event.keyCode === 32 || event.keyCode === 9)) {
      event.preventDefault();
    }
  }

  handleFamilyusersSelection(event) {
    this.selectedMembers = event;
  }

  onClearSearchInput() {
    this.searchStringState.setValue('');
    this._cd.detectChanges();
  }

  get isPlaceholderSelected(): boolean {
    return this.entityForm?.get('entityType')?.value === this.placeholderEntityId;
  }

  private flattenVaultList(vaults: any): any[] {
    if (!Array.isArray(vaults)) {
      return [];
    }
    return vaults.reduce((acc: any[], item: any) => {
      if (Array.isArray(item)) {
        acc.push(...item);
      } else if (item) {
        acc.push(item);
      }
      return acc;
    }, []);
  }

  private extractVaultIdFromUrl(): string | null {
    try {
      const url = this._router.url ?? '';
      const [path, query = ''] = url.split('?');
      const segments = path.split('/').filter((segment) => !!segment);
      const vaultIndex = segments.findIndex((segment) => segment.toLowerCase() === 'vault');
      if (vaultIndex !== -1 && segments[vaultIndex + 1]) {
        return segments[vaultIndex + 1];
      }
      if (query) {
        const params = new URLSearchParams(query.replace(/;/g, '&'));
        if (params.has('vaultId')) {
          return params.get('vaultId');
        }
      }
    } catch (error) {
      // ignore url parsing errors
    }
    return null;
  }

  private getPreferredPlaceholderVaultId(): any {
    const broadcastId = this.selectedVaultFromBroadcast?.id;
    if (broadcastId !== undefined && broadcastId !== null) {
      const matchedVault = this.placeholderVaultOptions?.find((vault) => String(vault?.id) === String(broadcastId));
      return matchedVault ? matchedVault.id : broadcastId;
    }
    if (this.defaultVaultIdFromUrl) {
      const matchedVault = this.placeholderVaultOptions?.find((vault) => String(vault?.id) === String(this.defaultVaultIdFromUrl));
      if (matchedVault) {
        return matchedVault.id;
      }
      return this.defaultVaultIdFromUrl;
    }
    return this.placeholderVaultOptions?.[0]?.id ?? null;
  }

  selectAllContent($event) {
    $event.target.select();
  }

  closeDialog() {
    // Clear placeholder vault selection when dialog closes
    const placeholderControl = this.entityForm?.get('placeholderVault');
    if (placeholderControl) {
      placeholderControl.setValue('');
      this.vaultSelectionBroadcastService.clearSelectedVault();
    }
    this.dialogRef.close({ confirmation: true });
  }

  ngOnDestroy() {
    // Clear placeholder vault selection when component is destroyed
    const placeholderControl = this.entityForm?.get('placeholderVault');
    if (placeholderControl) {
      placeholderControl.setValue('');
      this.vaultSelectionBroadcastService.clearSelectedVault();
    }
    this.subscription?.unsubscribe();
  }
}
